import { browserStorage } from './localStorage'
import Logger from 'Logger'

export function setErrorTolocalStorage(err) {
  if (NODE_ENV === 'development') {
    Logger.error('ERROR', err)
    setError(err)
  }
}

function setError(err) {
  var KEY = 'mall-errors'
  if (browserStorage.available()) {
    var errors = browserStorage.get(KEY)
    if (!errors) {
      browserStorage.set(KEY, [])
      errors = browserStorage.get(KEY)
    }
    errors.unshift(err.toString())
    if (errors.length > 50) {
      errors.length = 50
    }
    browserStorage.set(KEY, errors)
  }
}
